import { globalConstants } from '../constants'
import { globalService } from '../services'
import { alertActions } from './alert.actions'

export const globalActions = {
	getBankAll,
	searchCustomer,
	getYaaUserProfileById,
}

function getBankAll() {
	return dispatch => {
		dispatch(request())

		globalService.GetBankAll().then(
			banks => {
				setTimeout(() => {
					dispatch(success(banks))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: globalConstants.GET_BANK_REQUEST }
	}

	function success(banks) {
		return { type: globalConstants.GET_BANK_SUCCESS, banks }
	}

	function failure(error) {
		return { type: globalConstants.GET_BANK_FAILURE, error }
	}
}

function searchCustomer(IdNumber) {
	return dispatch => {
		dispatch(request())

		globalService.SearchCustomer({ IdNumber: IdNumber }).then(
			search_customer => {
				setTimeout(() => {
					dispatch(success(search_customer))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: globalConstants.GET_SEARCH_CUSTOMER_REQUEST }
	}

	function success(search_customer) {
		return { type: globalConstants.GET_SEARCH_CUSTOMER_SUCCESS, search_customer }
	}

	function failure(error) {
		return { type: globalConstants.GET_SEARCH_CUSTOMER_FAILURE, error }
	}
}

function getYaaUserProfileById(id) {
	return dispatch => {
		dispatch(request())

		globalService.getYaaUserProfileById(id).then(
			user_yaa_profile => {
				setTimeout(() => {
					dispatch(success(user_yaa_profile))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: globalConstants.GET_USER_YAA_BY_ID_REQUEST }
	}
	function success(user_yaa_profile) {
		return { type: globalConstants.GET_USER_YAA_BY_ID_SUCCESS, user_yaa_profile }
	}
	function failure(error) {
		return { type: globalConstants.GET_USER_YAA_BY_ID_FAILURE, error }
	}
}
